module.exports = __webpack_public_path__ + "img/GMapIcon.2416e762.png";